<template>
  <validation-representative :validation_requestable="model">
  </validation-representative>
  <!-- <ul>
    <li>{{this.model.decoded_type}} (
        <em v-if="this.model.representative_main">
          principal
        </em>
        <em v-else>
          secondaire
        </em> )
    </li>
    <li> {{this.model.decoded_civility}} {{this.model.first_name}} {{this.model.last_name}} (<em>{{this.model.decoded_representative_quality}}</em>)
    </li>
    <li v-if="this.model.created_at">
      Crée le <strong>{{ this.model.created_at | moment-date }}</strong>
    </li>
    <li v-if="this.model.representative_end_date">
      Valide jusqu'au <strong>{{ this.model.representative_end_date | moment-date }}</strong>
    </li>
    <li v-if="this.model.email">
      Email: <a :href="'mailto:' + this.model.email">{{this.model.email}}</a></span>
    </li>
    <li v-if="this.model.mobile_phone">
      Mobile: {{this.model.mobile_phone}}
    </li>
    <li v-if="this.model.phone">
      Téléphone: {{this.model.phone}}
    </li>

  </ul> -->
</template>

<script>
  import ValidationRepresentative from "./Details/ValidationRequestable/Representative"
  export default {

    name:"ModelRepresentative",

    props:["model", "title"],

    components:{
      ValidationRepresentative
    },

  }

</script>



// WEBPACK FOOTER //
// client/components/Demands/ModelRepresentative.vue